module.exports = __webpack_public_path__ + "static/media/2.6782763e.jpg";